// extracted by mini-css-extract-plugin
export default {"header":"report_name_modal-module___header___c0ba6118","inputRoot":"report_name_modal-module___inputRoot___b140ba7f","link":"report_name_modal-module___link___dea8224f"};